import { SlackIcon } from 'lucide-react';

import { cn } from '@/lib/shadcn/utils';
import { Heading } from '@/modules/ui/components/heading/Heading';
import { Paragraph } from '@/modules/ui/components/paragraph/Paragraph';

interface SlackConnectResultProps {
  title: string;
  description: string;
  status: 'success' | 'failure' | 'cancelled';
  actions?: React.ReactNode;
}

export const SlackConnectResult = ({
  title,
  description,
  status,
  actions,
}: SlackConnectResultProps) => {
  const iconBg = {
    success: 'bg-green-100 text-green-700',
    failure: 'bg-red-100 text-red-700',
    cancelled: 'bg-neutral-100 text-neutral-600',
  }[status];

  return (
    <div className="mx-auto max-w-xl space-y-6 py-16 text-center">
      <div
        className={cn(
          'mx-auto flex h-16 w-16 items-center justify-center rounded-full',
          iconBg,
        )}
      >
        <SlackIcon className="h-7 w-7" />
      </div>

      <Heading variant="h2">{title}</Heading>
      <Paragraph variant="body">{description}</Paragraph>

      {actions && (
        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          {actions}
        </div>
      )}
    </div>
  );
};
